// Effets sonores synthétisés (aucun fichier à charger).
let ctx = null;

function getCtx() {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  return ctx;
}

// À appeler pendant un geste utilisateur (clic) pour débloquer l'audio.
export function unlockAudio() {
  const c = getCtx();
  if (c && c.state === "suspended") c.resume().catch(() => {});
}

// Un « toc » de bois : bouffée de bruit filtrée + thud grave, décroissance rapide.
function knock(c, t, vol) {
  const dur = 0.13;
  const buffer = c.createBuffer(1, Math.max(1, Math.floor(c.sampleRate * dur)), c.sampleRate);
  const d = buffer.getChannelData(0);
  for (let i = 0; i < d.length; i++) {
    const env = Math.pow(1 - i / d.length, 3);
    d[i] = (Math.random() * 2 - 1) * env;
  }
  const src = c.createBufferSource();
  src.buffer = buffer;
  const bp = c.createBiquadFilter();
  bp.type = "bandpass";
  bp.frequency.value = 340;
  bp.Q.value = 1.3;
  const g = c.createGain();
  g.gain.value = vol;
  src.connect(bp).connect(g).connect(c.destination);
  src.start(t);

  const osc = c.createOscillator();
  osc.type = "sine";
  osc.frequency.setValueAtTime(185, t);
  osc.frequency.exponentialRampToValueAtTime(68, t + 0.1);
  const og = c.createGain();
  og.gain.setValueAtTime(vol * 0.9, t);
  og.gain.exponentialRampToValueAtTime(0.0001, t + 0.12);
  osc.connect(og).connect(c.destination);
  osc.start(t);
  osc.stop(t + 0.14);
}

// Coup de marteau du Juge : deux tocs secs et discrets.
export function playGavel(volume = 0.16) {
  const c = getCtx();
  if (!c) return;
  if (c.state === "suspended") c.resume().catch(() => {});
  const t = c.currentTime + 0.02;
  knock(c, t, volume);
  knock(c, t + 0.16, volume * 0.85);
}

// Léger « plongeon » dans le terrier : glissando descendant doux + shimmer.
export function playDive(volume = 0.11) {
  const c = getCtx();
  if (!c) return;
  if (c.state === "suspended") c.resume().catch(() => {});
  const t = c.currentTime + 0.01;
  const dur = 0.5;
  const osc = c.createOscillator();
  osc.type = "sine";
  osc.frequency.setValueAtTime(740, t);
  osc.frequency.exponentialRampToValueAtTime(180, t + dur);
  const lp = c.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.setValueAtTime(2600, t);
  lp.frequency.exponentialRampToValueAtTime(700, t + dur);
  const g = c.createGain();
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(volume, t + 0.05);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  osc.connect(lp).connect(g).connect(c.destination);
  osc.start(t);
  osc.stop(t + dur + 0.02);

  const osc2 = c.createOscillator();
  osc2.type = "triangle";
  osc2.frequency.setValueAtTime(1320, t);
  osc2.frequency.exponentialRampToValueAtTime(430, t + dur * 0.8);
  const g2 = c.createGain();
  g2.gain.setValueAtTime(0.0001, t);
  g2.gain.exponentialRampToValueAtTime(volume * 0.4, t + 0.04);
  g2.gain.exponentialRampToValueAtTime(0.0001, t + dur * 0.8);
  osc2.connect(g2).connect(c.destination);
  osc2.start(t);
  osc2.stop(t + dur);
}
